import { invoiceStatusEnumList } from '../../../components/AgGrid/enumLists'

const invoiceStatusValueGetter = (props) => {
  const { value } = props
  return invoiceStatusEnumList(value)
}

export default invoiceStatusValueGetter
